import { render, staticRenderFns } from "./shipment-edit.vue?vue&type=template&id=7b42a541&scoped=true"
import script from "./shipment-edit.vue?vue&type=script&lang=js"
export * from "./shipment-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b42a541",
  null
  
)

export default component.exports